// Sales Activity REST client — FE-SCRM-024.
//
// Wraps the BE-SCRM-023 endpoints under /api/v1/sales/activities.

import { api } from "@/api/client";

import type {
  ActivityCreateInput,
  ActivityListQuery,
  ActivityListResponse,
  ActivityPatchInput,
  SalesActivity,
} from "./types";


function _encodeQuery(query: ActivityListQuery): string {
  const params = new URLSearchParams();
  if (query.status) params.set("status", query.status);
  if (query.type) params.set("type", query.type);
  if (query.due) params.set("due", query.due);
  if (query.owner) params.set("owner", query.owner);
  if (query.prospect_id) params.set("prospect_id", query.prospect_id);
  if (query.opportunity_id) {
    params.set("opportunity_id", query.opportunity_id);
  }
  if (query.contact_id) params.set("contact_id", query.contact_id);
  const qs = params.toString();
  return qs ? `?${qs}` : "";
}


export function fetchActivityList(
  query: ActivityListQuery,
  opts?: { signal?: AbortSignal },
): Promise<ActivityListResponse> {
  return api.get<ActivityListResponse>(
    `/api/v1/sales/activities${_encodeQuery(query)}`,
    opts,
  );
}


export function createActivity(
  input: ActivityCreateInput,
): Promise<SalesActivity> {
  return api.post<SalesActivity>("/api/v1/sales/activities", input);
}


export function patchActivity(
  activity_id: string, patch: ActivityPatchInput,
): Promise<SalesActivity> {
  return api.patch<SalesActivity>(
    `/api/v1/sales/activities/${activity_id}`, patch,
  );
}


export function deleteActivity(
  activity_id: string,
): Promise<{ deleted: true }> {
  return api.delete<{ deleted: true }>(
    `/api/v1/sales/activities/${activity_id}`,
  );
}


export function completeActivity(
  activity_id: string, completed_at?: string,
): Promise<SalesActivity> {
  return api.post<SalesActivity>(
    `/api/v1/sales/activities/${activity_id}/complete`,
    completed_at ? { completed_at } : {},
  );
}


export function revertActivityCompletion(
  activity_id: string,
): Promise<SalesActivity> {
  return api.post<SalesActivity>(
    `/api/v1/sales/activities/${activity_id}/revert`,
    {},
  );
}


export function cancelActivity(
  activity_id: string,
): Promise<SalesActivity> {
  return api.post<SalesActivity>(
    `/api/v1/sales/activities/${activity_id}/cancel`,
    {},
  );
}
